import { Component, Inject } from '@angular/core'
import { MatCard } from '@angular/material/card'
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
} from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

@Component({
  selector: 'dialog-to-choose',
  imports: [MatCard, MatDialogClose, MatIcon, MatButton, MatProgressSpinner],
  templateUrl: './dialog-to-choose.component.html',
  styleUrl: './dialog-to-choose.component.scss',
})
export class DialogChooseComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
